export default {
  LOAD_CLAIM_REVIEW_OVERVIEW_START: 'LoadClaimReviewOverviewStart',
  LOAD_CLAIM_REVIEW_OVERVIEW_END: 'LoadClaimReviewOverviewEnd',
  TOGGLE_REJECT_DIALOG: 'ToggleClaimReviewRejectDialog',
  CLEANUP_CLAIM_REVIEW_OVERVIEW: 'CleanupClaimReviewOverview'
};
